import React from "react";
import "../css/Gallery.css";

const Gallery2 = () => {
  return (
    <div className="gallery2">

      {/* HERO */}
      <section className="g2-hero">
        <h1>FLEXOR VISUALS</h1>
        <p>A study of movement, discipline & human design.</p>
      </section>


      {/* SECTION 1 - SPLIT SHOWCASE */}
      <section className="g2-showcase">
        <img 
          src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg"
          alt="Athlete strength"
          className="g2-showcase-img"
        />

        <div className="g2-showcase-text">
          <h2>THE ART OF CONTROL</h2>
          <p>
            Strength is not chaos—it's precision.  
            Intention applied with disciplined force.
          </p>
        </div>
      </section>


      {/* SECTION 2 - STAGGERED STACKS */}
      <section className="g2-stacks">
        <div className="stack-col left">
          <img src="https://images.pexels.com/photos/10039558/pexels-photo-10039558.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/4944004/pexels-photo-4944004.jpeg" alt="" />
        </div>

        <div className="stack-col right">
          <img src="https://images.pexels.com/photos/14843494/pexels-photo-14843494.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/2294363/pexels-photo-2294363.jpeg" alt="" />
        </div>
      </section>


      {/* NEW SECTION 3 — CINEMATIC VERTICAL STRIP (No horizontal scroll) */}
      <section className="g2-cinematic">
        <h2>CINEMATIC MOMENTS</h2>

        <div className="cinematic-grid">
          <img src="https://images.pexels.com/photos/9288101/pexels-photo-9288101.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/2294361/pexels-photo-2294361.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/6389869/pexels-photo-6389869.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/7674497/pexels-photo-7674497.jpeg" alt="" />
        </div>
      </section>


      {/* SECTION 4 - MONOCHROME MOMENTS */}
      <section className="g2-mono">
        <div className="mono-item">
          <img src="https://images.pexels.com/photos/8611349/pexels-photo-8611349.jpeg" alt="" />
          <span>FOCUS</span>
        </div>

        <div className="mono-item">
          <img src="https://images.pexels.com/photos/5327476/pexels-photo-5327476.jpeg" alt="" />
          <span>FORM</span>
        </div>

        <div className="mono-item">
          <img src="https://images.pexels.com/photos/8436604/pexels-photo-8436604.jpeg" alt="" />
          <span>FLOW</span>
        </div>
      </section>


      {/* END SECTION */}
      <section className="g2-end">
        <h2>THE FLEXOR OF MOVEMENT</h2>
      </section>

    </div>
  );
};

export default Gallery2;
